/**
 * Company self-registration (owner sign-up) API.
 *
 * Provisioning a new tenant spans Keycloak (organization + owner user) and platform
 * state, so it is a BFF orchestration (`POST /api/v1/registration/company`) rather than
 * plain Keycloak self-registration. The owner then verifies their email and signs in.
 */
import { apiClient } from '@/shared/api';

export interface CompanyRegistrationRequest {
  companyName: string;
  ownerName: string;
  ownerEmail: string;
}

export interface CompanyRegistrationResult {
  /** Newly provisioned tenant (organization) id. */
  tenantId: string;
  /** e.g. `PENDING_EMAIL_VERIFICATION`. */
  status: string;
}

export const registerCompany = async (
  body: CompanyRegistrationRequest,
): Promise<CompanyRegistrationResult> =>
  (await apiClient.post<CompanyRegistrationResult>('/api/v1/registration/company', body)).data;
